export const insurers = {
  QBE: 'QBE',
  ASSETINSURE: 'ASSETINSURE',
  VMIA: 'VMIA',
  ICARE: 'ICARE',
  QBCC: 'QBCC',
};
